<template>
  <!-- 机构信息 -->
  <div
    :class="{
      'org-info': !isH5,
      'h5-org-info': isH5,
      'electron-org-info': isElectron,
    }"
    @click="goOrgPage"
  >
    <div class="org-card" @click="isH5 ? jumpUrl(`/org/${orgId}`) : ''">
      <img
        v-if="orgInfo.org_logo"
        class="logo"
        :src="orgInfo.org_logo + '?imageView2/0/w/100'"
        alt="logo"
      />
      <img
        v-else
        class="logo"
        :src="defaultOrgLogo"
        alt="logo"
      />
      <div class="info-wrap">
        <p class="org-name">
          <span>{{ orgInfo.org_name }}</span>
        </p>
        <p class="info">
          {{ orgInfo.org_desc }}
        </p>
      </div>
      <div class="operation" v-if="!isH5">
        <el-button class="home-btn" @click="jumpUrl(`/org/${orgId}`)"
          >主页</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile, getCdnUrl } from "@saas/components/src";
export default {
  props: {
    orgInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isH5: {
      type: Boolean,
      default: false,
    },
    orgId: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      isElectron: window.isElectron,
      isMobile: isMobile(),
      defaultOrgLogo: getCdnUrl("/cdn/static/images/default_org_logo.png", "?imageView2/0/w/100", "comettech"),
    };
  },
  methods: {
    goOrgPage() {
      if (!this.isH5) return;
      const inReview = this.$route.query?.inReview === "1" ? "?inReview=1" : "";
      this.jumpUrl(`/org/${this.orgId}${inReview}`);
    },
    jumpUrl(url) {
      if (window.isElectron || this.isMobile) {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.org-info {
  background: #fff;
  padding: 12px 16px 0;
  .org-card {
    width: 100%;
    height: 83px;
    border-radius: 24px;
    background: $saas-bg-color;
    padding: 16px 22px 16px 16px;
    display: flex;
    align-items: center;
  }
  .logo {
    width: 50px;
    height: 50px;
    margin-right: 12px;
    border-radius: 16px;
    border: 1px solid #e2e2e2;
    object-fit: cover;
  }
  .info-wrap {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    margin-right: 40px;
    width: 0;
    .org-name {
      font-weight: 500;
      font-size: 18px;
      color: #000000;
      line-height: 25px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      word-break: break-all;
      line-break: anywhere;
    }
    .info {
      position: relative;
      bottom: -3px;
      font-weight: 400;
      font-size: 14px;
      color: $plain-text-color;
      line-height: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .operation {
    .home-btn {
      border: none;
      display: flex;
      align-items: center;
      height: 28px;
      background: linear-gradient(
        132deg,
        $linear-gradient-begin 0%,
        $linear-gradient-end 100%
      );
      border-radius: 14px;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      line-height: 28px;
      padding: 0 19px;
    }
  }
}

// 适配样式
.h5-org-info {
  background: #fff;
  padding: 0 0.32rem 0.32rem;
  .org-card {
    display: flex;
    align-items: center;
    padding: 0.43rem 0.32rem;
    background: $saas-bg-color;
    border-radius: 0.32rem;
  }

  .logo {
    width: 1.09rem;
    height: 1.09rem;
    margin-right: 0.21rem;
    object-fit: cover;
    border-radius: 50%;
    border: 0.01rem solid #e2e2e2;
  }
  .info-wrap {
    flex: 1;
    width: 0;
    .org-name {
      font-weight: 500;
      font-size: 0.43rem;
      color: #0d1400;
      line-height: 0.53rem;
      margin-bottom: 0.24rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      word-break: break-all;
      line-break: anywhere;
    }
    .info {
      width: 100%;
      font-size: 0.32rem;
      color: #515350;
      line-height: 0.4rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      word-break: break-all;
      line-break: anywhere;
    }
  }
  .operation {
    .home-btn {
      border: none;
      display: flex;
      align-items: center;
      height: 0.64rem;
      background: linear-gradient(
        132deg,
        $linear-gradient-begin 0%,
        $linear-gradient-end 100%
      );
      border-radius: 0.21rem;
      font-weight: 500;
      font-size: 0.32rem;
      color: #ffffff;
      line-height: 0.44rem;
      padding: 0 0.27rem;
    }
  }
}

// 客户端
.org-info.electron-org-info {
  .org-card {
    height: 74px;
    border-radius: 16px;
    padding: 0 22px 0 16px;
  }
  .info-wrap {
    .org-name {
      font-size: 16px;
      line-height: 22px;
    }
    .info {
      position: relative;
      bottom: -3px;
      font-size: 12px;
      line-height: 17px;
    }
  }
}
</style>
